/**
 * GraphQL query for assigning moderation cases to a moderator
 */

import { gql } from '@apollo/client';

export const ASSIGN_MODERATION_CASE = gql`
  query AssignModerationCase($communityId: ID!, $topicName: String!) {
    assignModerationCase(communityId: $communityId, topicName: $topicName) {
      id
      communityId
      topicName
      subjectId
      caseId
      pk
      report {
        communityId
        topicName
        subjectId
        timestamp
        contents {
          contentId
          contentType
          data
          labels {
            labels {
              name
              confidence
            }
            source
          }
        }
        reportSource {
          id
          type
        }
      }
      status
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
    }
  }
`;
